import { Card, CardContent, CardHeader, Divider } from "@mui/material";
import GeneralForm from "./GeneralForm";

export default function ProjectSettingGeneral() {
    return (
        <Card variant="outlined">
            <CardHeader title="General"></CardHeader>
            <Divider variant="middle" />
            <CardContent>
                <GeneralForm />

                {/**
                <Typography variant="h5" gutterBottom sx={{ marginTop: 3 }}>
                    Project status
                </Typography>
                */}
            </CardContent>
        </Card>
    );
}
